export default "__VITE_ASSET__DiSnpStk__"